import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { CHAPTERS } from "../../data";

export const Ethos = () => (
  <section id="ethos" className="relative py-24 md:py-40 grid-lines" data-testid="ethos-section">
    <div className="mx-auto max-w-[1600px] px-5 md:px-10">
      <Reveal>
        <div className="flex items-center gap-4 font-mono text-xs uppercase tracking-[0.25em] text-forge mb-8">
          <span className="w-10 h-px bg-forge" />
          The Ethos / Manifesto
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-head font-bold uppercase tracking-tight text-4xl md:text-6xl max-w-4xl leading-[0.95]">
          Four decades of building power people can bet a factory on.
        </h2>
      </Reveal>

      <div className="mt-20 md:mt-28 grid gap-px bg-white/10 border border-white/10">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.08}>
            <div className="group relative bg-void px-6 md:px-12 py-12 md:py-16 grid md:grid-cols-12 gap-6 md:gap-10 items-start overflow-hidden">
              <span className="absolute -top-8 right-4 font-head font-black text-white/[0.04] text-[9rem] md:text-[16rem] leading-none pointer-events-none select-none">
                {c.num}
              </span>
              <div className="md:col-span-3 font-mono text-sm text-forge tracking-[0.2em]">
                CH.{c.num}
              </div>
              <h3 className="md:col-span-5 font-head font-bold uppercase text-3xl md:text-4xl leading-[0.95] tracking-tight group-hover:text-forge transition-colors">
                {c.title}
              </h3>
              <p className="md:col-span-4 text-plasma/65 leading-relaxed relative z-10">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
